import { Component, NgZone, ChangeDetectionStrategy, Signal, computed } from "@angular/core";
import { TranslocoModule } from "@ngneat/transloco";
import { FuturesModeService } from "@services";
import { LineBreaksPipe } from "src/app/core/pipe/line-break.pipe";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, LineBreaksPipe, SvgIconComponent],
})
export class FooterComponent {
  public textVisible: boolean = false;
  public currentYear: number = new Date().getFullYear();

  public readonly copyrightKey: Signal<string> = computed(() =>
    this._futuresModeService.isFuturesRoute() ? "copyrightLLC" : "copyright",
  );

  constructor(
    private _ngZone: NgZone,
    private _futuresModeService: FuturesModeService,
  ) {}

  public additionalText(): void {
    this.textVisible = !this.textVisible;

    if (this.textVisible) {
      this._ngZone.runOutsideAngular(() => {
        const element = document.getElementById("targetElement");
        if (element) {
          setTimeout(function () {
            element.scrollIntoView({ behavior: "smooth" });
          }, 350);
        }
      });
    }
  }
}
